<template>
  <div>
    <popup-dialog
        v-if="openGallery"
        v-model="openGallery">
      <span slot="header">{{ $t('pages.media.addMedia') }}</span>
      <v-container v-if="shouldHideImageUpload">
        <v-row justify="center">
          <label>{{ $t('pages.media.cannotUploadImageMobile') }}</label>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row justify="center">
          <label v-if="!loading" for="image-input" class="drop-zone text--h4 mt-3 mb-1 rounded-lg pointer">
            <span>{{ $t('pages.media.addMedia') }}</span>
            <v-icon>mdi-upload</v-icon>
          </label>
            <v-progress-circular v-else indeterminate size="40" class="ma-2"/>
        </v-row>
      </v-container>

      <input hidden id="image-input" type="file"  accept=".jpg,.jpeg,.png"  @change="onFileChange">

      <div class="separator" />
      <select-from-gallery :images="images" @updateMediaSrc="updateMediaSrc" />
    </popup-dialog>
    <media-gallery-btn @click.native="openGallery =true" :label="label" />
    <v-dialog persistent max-width="800" v-model="openCropperDialog">
      <cropper :aspect-ratio="imageWidth / imageHeight"
               :fileType = "saveOriginalFileType ? originalFileType: undefined"
               :src="imageUrl"
               :width="imageWidth"
               :height="imageHeight"
               @crop-confirmed="confirmCrop"
               @closeUpload="cancel"
      />


    </v-dialog>
  </div>
</template>
<script>

import { types } from "./Media.module";
import MediaGalleryBtn from "./MediaGalleryBtn";
import axios from "axios";
import Cropper from "./Cropper";
import SelectFromGallery from "./SelectFromGallery";

/**
 * MediaGallery component manage selecting image, support:
 * Uploading and editing new image and selecting images from the gallery.
 */
export default {
  name: "MediaGallery",
  components: { SelectFromGallery, MediaGalleryBtn, Cropper },
  props: { label: String,crop: { type: Boolean, default: true }, imageWidth: { default: 1720 }, imageHeight: { default: 1080 }, saveOriginalFileType: {default: false} },
  data() {
    return {
      openGallery: false,
      imageUrl: null, //
      openCropperDialog: false,
      fileName: "",
      originalFileType: undefined,
      loading: false
    };
  },
  computed: {
    images() {
      return this.$store.state.MediaModule.medias;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    shouldHideImageUpload() {
      // Check if the user is on a mobile device and if the user is an educator
      return this.isMobile && this.$store.state.AuthModule.user?.is_edu;
    }


  },
  created() {
    this.$store.dispatch(types.FETCH);
  },
  methods: {
    updateMediaSrc(src) {
      this.imageUrl = undefined;
      this.$emit("selected", src);
      this.openGallery = false;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageUrl = e.target.result;
        this.openCropperDialog = true
        this.loading = false
      };
      reader.readAsDataURL(file);
    },
    onFileChange(event) {
      this.loading = true;
      if (event.target.files[0]) {
        const file = event.target.files[0]
        this.fileName = file.name;
        this.originalFileType = file.type
        if(this.crop){
          this.createImage(file);
        }
        else
          this.uploadToServer(file)
      }
    },
    async confirmCrop({ file, url }) {
      this.openCropperDialog = false;
      await this.uploadToServer(file)
    },


    async uploadToServer(blob) {
      const formData = new FormData();
      formData.append("test", blob, this.fileName);
      // Send the FormData to the server using Axios
      try {
        const response = await axios.post("/api/media", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.loading = false
        this.updateMediaSrc(response.data)
      } catch (error) {
        console.error("Error uploading image:", error);

      }
    },
    async cancel() {
      this.openCropperDialog = false;
      this.imageUrl = undefined;
    }
  },
};
</script>

<style scoped lang="scss">
.drop-zone {
  color: rgba(0, 0, 0, .8);
  border: 2px dashed rgba(0, 0, 0, .8);
  padding: 5px;
}

.separator {
  height: 0.5px;
  background-color: #1a202c;
  margin: 15px 0;
}

.cropper-container img {
  max-width: 100%;
  margin-top: 20px;
}
</style>
